export const categoriesOption = [
  { label: 'All News', value: 'all' },
  { label: 'AI', value: 'ai' },
  { label: 'Technology', value: 'technology' },
  { label: 'Startups', value: 'startups' },
  { label: 'Science', value: 'science' },
  { label: 'Internet', value: 'internet' },
  { label: 'Social', value: 'social' },
  { label: 'OpenSource', value: 'opensource' },
  { label: 'bitcoin', value: 'bitcoin' },
  { label: 'Machine Learning', value: 'machine learning' },
]
export const publisherOption = [
  { label: 'techchrunch.com', value: 'https://techcrunch.com/' },
  {
    label: 'arstechnica.com',
    value: 'https://arstechnica.com',
  },
  { label: 'gizmodo.com', value: 'https://gizmodo.com' },
  { label: 'theverge.com', value: 'https://www.theverge.com/' },
  { label: 'mashable.com', value: 'https://mashable.com/feeds/rss/all' },
  { label: 'wired.com', value: 'https://www.wired.com' },
  { label: 'Inman.com', value: 'https://www.inman.com' },
]
export const sortByOptions = [
  { label: 'Relevance', value: 'relevance' },
  { label: 'Date', value: 'date' },
  { label: 'Title', value: 'title' },
]

export const selectModelOption = [
  { label: 'Summarize', value: 'summarize', icon: 'face-color' },
  { label: 'Change Voice', value: 'change-voice', icon: 'text-t' },
  { label: 'Narrate', value: 'narrate', icon: 'hanger' },
  { label: 'Change sentiment', value: 'change-sentiment', icon: 'bottles' },
]
